module.exports = __webpack_public_path__ + "img/banner3.653f8bb2.gif";